import React, { useState, useEffect } from 'react';
import toast from '../services/toast';
import './Toast.css';

const ICONS = { success: '✅', error: '❌', info: 'ℹ️' };
const DURATION = 4000;

export default function Toast() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    return toast.subscribe((item) => {
      setItems(prev => [...prev, item]);
      setTimeout(() => {
        setItems(prev => prev.filter(i => i.id !== item.id));
      }, DURATION);
    });
  }, []);

  if (!items.length) return null;

  return (
    <div className="toast-container">
      {items.map(item => (
        <div key={item.id} className={`toast ${item.type}`}>
          <span className="toast-icon">{ICONS[item.type]}</span>
          <span className="toast-msg">{item.message}</span>
        </div>
      ))}
    </div>
  );
}
